import React from 'react';
import styled from 'styled-components';

const AvatarWrapper = styled.div<{ color: string, $borderColor: string }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #${props => props.color};
  border: 1px solid #${props => props.$borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #${props => props.$borderColor};
`;

// Helper function to darken a color
const darkenColor = (color: string, amount: number): string => {
  return color.replace(/^#/, '').replace(/../g, color => 
    ('0' + Math.min(255, Math.max(0, parseInt(color, 16) - amount)).toString(16)).substr(-2)
  );
};

// Helper function to lighten a color
const lightenColor = (color: string, amount: number): string => {
    return color.replace(/^#/, '').replace(/../g, color => 
      ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2)
    );
  };

interface AvatarProps {
  name: string;
  color: string;
}

const Avatar: React.FC<AvatarProps> = ({ name, color }) => {
  const initial = name.charAt(0).toUpperCase();
  const borderColor = darkenColor(color, 40); // 2x darker shade
  const backgroundColor = lightenColor(color, 80); // 2x lighter shade

  return (
    <AvatarWrapper color={backgroundColor} $borderColor={borderColor}>
      {initial}
    </AvatarWrapper>
  );
};

export default Avatar;